import { exportFile } from 'utils/custom';

export default (data, filename) => {
  exportFile(data, 'text/calendar', 'ics', filename);
};
